export const MIN_COMMENT_LENGTH = 2;
export const MAX_COMMENT_LENGTH = 511;
